export var ifOverflowMatches = function ifOverflowMatches(props, value) {
  var alwaysShow = props.alwaysShow;
  var ifOverflow = props.ifOverflow;

  if (alwaysShow) {
    ifOverflow = 'extendDomain';
  }

  return ifOverflow === value;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/recharts/es6/util/IfOverflowMatches.js
// module id = 154
// module chunks = 0